import { ThumbDown, ThumbUp } from '@mui/icons-material'
import { Box } from '@mui/material'
import { green, red } from '@mui/material/colors'
import { type FC } from 'react'

export type Feedback = 'positive' | 'negative'

// Accepts the raw GraphQL string; renders null for anything unknown.
interface FeedbackPillProps {
    feedback: string | null | undefined
}

export const FeedbackPill: FC<FeedbackPillProps> = ({ feedback }) => {
    if (feedback === 'positive') {
        return (
            <Box sx={{ color: green[900], display: 'inline-flex' }}>
                <ThumbUp sx={{ fontSize: '1rem' }} />
            </Box>
        )
    }
    if (feedback === 'negative') {
        return (
            <Box sx={{ color: red[900], display: 'inline-flex' }}>
                <ThumbDown sx={{ fontSize: '1rem' }} />
            </Box>
        )
    }
    return null
}
